if (!customElements.get('dio-desktop-mega-menu')) {
  customElements.define(
    'dio-desktop-mega-menu',
    class DioDesktopMegaMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.dioHoverReady === 'true') return;

        this.details = this.querySelector('details.mega-menu');
        this.summary = this.details?.querySelector(':scope > summary');
        this.panel = this.summary?.nextElementSibling;
        if (!this.details || !this.summary || !this.panel) return;

        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.handleEnter = this.open.bind(this);
        this.handleLeave = this.scheduleClose.bind(this);
        this.handlePanelEnter = this.cancelClose.bind(this);
        this.handleToggle = this.syncState.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handleViewportChange = this.onViewportChange.bind(this);

        this.addEventListener('mouseenter', this.handleEnter);
        this.addEventListener('mouseleave', this.handleLeave);
        this.addEventListener('keydown', this.handleKeydown);
        this.panel.addEventListener('mouseenter', this.handlePanelEnter);
        this.details.addEventListener('toggle', this.handleToggle);
        this.desktopQuery.addEventListener('change', this.handleViewportChange);

        this.dataset.dioHoverReady = 'true';
        this.syncState();
      }

      disconnectedCallback() {
        this.cancelClose();
        this.removeEventListener('mouseenter', this.handleEnter);
        this.removeEventListener('mouseleave', this.handleLeave);
        this.removeEventListener('keydown', this.handleKeydown);
        this.panel?.removeEventListener('mouseenter', this.handlePanelEnter);
        this.details?.removeEventListener('toggle', this.handleToggle);
        this.desktopQuery?.removeEventListener('change', this.handleViewportChange);
        delete this.dataset.dioHoverReady;
      }

      open() {
        if (!this.desktopQuery.matches) return;

        this.cancelClose();
        this.closeSiblingMenus();
        this.details.open = true;
        this.syncState();
      }

      scheduleClose() {
        if (!this.desktopQuery.matches) return;

        this.cancelClose();
        this.closeTimer = window.setTimeout(() => this.close(), 160);
      }

      close(restoreFocus = false) {
        this.cancelClose();
        this.details.open = false;
        this.syncState();
        if (restoreFocus) this.summary.focus();
      }

      cancelClose() {
        if (!this.closeTimer) return;
        window.clearTimeout(this.closeTimer);
        this.closeTimer = undefined;
      }

      closeSiblingMenus() {
        this.closest('.header__inline-menu')
          ?.querySelectorAll('dio-desktop-mega-menu')
          .forEach((menu) => {
            if (menu !== this && menu.details?.open) menu.close();
          });
      }

      syncState() {
        const isOpen = this.details.open;
        this.summary.setAttribute('aria-expanded', isOpen.toString());
        this.classList.toggle('dio-is-open', isOpen);
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.preventDefault();
        this.close(true);
      }

      onViewportChange(event) {
        if (!event.matches && this.details.open) this.close();
      }
    }
  );
}
